import { UserInfoService } from './../../shared-resources/services/user-info.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountActivationService } from '../services/account-activation.service';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpErrorHandlerService,
  MessageType,
} from 'src/app/shared-resources/services/http-error-handling.service';

@Component({
  selector: 'app-account-activation',
  templateUrl: './account-activation.component.html',
  styleUrls: ['./account-activation.component.less'],
})
export class AccountActivationComponent implements OnInit {
  public TOKEN!: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private activationService: AccountActivationService,
    private userInfoService: UserInfoService,
    private httpMessage: HttpErrorHandlerService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.TOKEN = queryParams['token'];
    this.userInfoService.setUserName(atob(queryParams['username']));
    if (this.TOKEN != null) {
      this.activationService
        .activate(this.TOKEN, queryParams['username'])
        .subscribe(
          () => {
            this.httpMessage.showTopFloatMessage(
              this.translate.instant('app.label.success'),
              MessageType.SUCCESS,
              this.translate.instant('app.account-activation.success')
            );
          },
          (error: any) => {
            this.httpMessage.showTopFloatMessage(
              error.error,
              MessageType.ERROR,
              this.translate.instant('app.account-activation.error')
            );
          }
        );
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  signin(): void {
    this.router.navigateByUrl('/login');
  }
}
